import React from 'react';

import { CommonStatusTag } from 'components/CommonStatusTag';

import { colors } from 'constants/colors';

import { StockTransferState } from 'data/__generated__';
import { STOCK_TRANSFERS_STATES_LABELS } from '../constants/states';

const getColorsFromState = (state: StockTransferState) => {
    switch (state) {
        case StockTransferState.Created:
            return { backgroundColor: colors.yellow, labelColor: colors.black };
        case StockTransferState.Aborted:
            return { backgroundColor: colors.red, labelColor: colors.pureWhite };
        case StockTransferState.Validated:
            return { backgroundColor: colors.green, labelColor: colors.black };
    }
};

export const StatusTag = ({ state, showHeading = false }: { state: StockTransferState; showHeading?: boolean }) => {
    const { backgroundColor, labelColor } = getColorsFromState(state);
    return (
        <CommonStatusTag
            backgroundColor={backgroundColor}
            labelColor={labelColor}
            label={STOCK_TRANSFERS_STATES_LABELS[state]}
            showHeading={showHeading}
        />
    );
};
